import {useContext} from 'react';

import type {Logger} from '../../Logger';
import {LoggerContext} from './LoggerContext';

interface UseErrorHandlerFunction {
  (): Logger;
}

const useErrorHandler: UseErrorHandlerFunction = () => {
  const logger = useContext(LoggerContext);

  if (!logger) {
    throw new Error(
      'You are trying to use the useErrorHandler hook without wrapping your app with the <ErrorHandlerProvider> (LoggerContext.Provider).',
    );
  }

  return logger;
};

export {useErrorHandler};
